import { batch, signal } from "@preact/signals-react"
import { userData } from "@signals"
import { INFO_MODAL_TABS, RENTAL_DATES_OPTIONS, REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

export const reportFormData = signal({})
export const isReportDrawerOpen = signal(false)
export const reportFormErrors = signal({})
export const reportFormNumSearches = signal(0)
export const useOfficePickup = signal(false)
export const useCsv = signal(false)
export const isCsvLoading = signal(false)
export const useManualExecution = signal(false)
export const isFormSubmitLoading = signal(false)
export const reportListStatusFilter = signal(['Enabled'])
export const reportListCellData = signal({})
export const reportListStatus = signal([])
export const reportListData = signal([])
export const isOpenInfoModal = signal(null)
export const isInfoModalHistoryLoading = signal(false)
export const selectedInfoModalTab = signal(INFO_MODAL_TABS.DETAILS)
export const reportListSearchSummaryID = signal(null)
export const reportListMultipleData = signal({ values: [], key: '', idReport: [], reportsInfo: [] })
export const isReportMultipleModalLoading = signal(null)
export const useExtrasAcriss = signal(true)
export const selectedReportTypeTab = signal(REPORT_TYPE_TABS.REPORTS)
//Functions

export const resetSignals = () => batch(() => {
	reportFormData.value = {}
	reportFormErrors.value = {}
	reportFormNumSearches.value = 0
	useOfficePickup.value = false
	useCsv.value = false
	isCsvLoading.value = false
	useManualExecution.value = false
	isFormSubmitLoading.value = false
	reportListStatusFilter.value = ['Enabled']
	reportListCellData.value = {}
	reportListStatus.value = []
	reportListData.value = []
	isOpenInfoModal.value = null
	isInfoModalHistoryLoading.value = false
	selectedInfoModalTab.value = INFO_MODAL_TABS.DETAILS
	reportListSearchSummaryID.value = null
	reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }
	isReportMultipleModalLoading.value = null
})

export const closeDrawer = () => batch(() => {
	reportFormData.value = {}
	reportFormErrors.value = []
	reportFormNumSearches.value = 0
	useManualExecution.value = false
	isReportDrawerOpen.value = false
})

export const setReportData = newData => {
	const allReports = [...reportListData.value]
	const targetIdx = allReports.findIndex(item => item.idReport === newData?.idReport)

	if (targetIdx !== -1) {
		allReports[targetIdx] = { ...allReports[targetIdx], ...newData }
	} else {
		allReports.unshift(newData)
	}
	reportListData.value = allReports
}


export const reportFormDataInnit = (reportData = {}) => {
	isReportDrawerOpen.value = true
	reportFormData.value = {
		filterWebSuppliersExclusion: false,
		filterProvidersExclusion: false,
		name: null,
		sites: [],
		idFuelPolicyFilter: null,
		filterIsPrepaid: null,
		idOfficeGroup: [],
		idOfficePickup: [],
		oneWayRoutes: [],
		sheets: [],
		idOfficeDropoff: null,
		timeFrom: null,
		timeTo: null,
		filterCategories: [],
		filterAcriss: [],
		idCurrency: null,
		idCurrencyTranslation: null,
		withinDays: [],
		lengthOfRental: [],
		daysMonitorized: null,
		terminationDate: null,
		checkinWeekdayFilter: [],
		checkinWeekdayFilterTranslation: null,
		manuallyExecution: false,
		idFrequencyWhen: [],
		idFrequencyWhenTranslation: [],
		frequencyHours: [],
		pickupDates: {},
		notificationEmailAux: null,
		notificationEmail: [],
		launchRepricing: false,
		// a one way report cannot export, so it generates unless the user switches it off
		generate: selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS || userData.value?.generateReport,
		hoursLimit: null,
		executionDateMin: null,
		executionDateMax: null,
		rentalDateOption: RENTAL_DATES_OPTIONS.SPECIFIC_DAYS,
		rentalDateOptionTranslation: null,
		daysSelected: [],
		weekSelected: [],
		...reportData
	}
}